<div class="custom-gap">
  <div class="content-container">
    <div class="description-container">
      <div class="d-flex flex-column gap-2">
        <p class="mb-0 title-text">Seleziona il numero di posti</p>
        <p class="mb-0 description-text">
          Stabilisci quanti posti sono disponibili per il lavoro in presenza.
        </p>
      </div>
    </div>
    <div class="sp-alert">
      <img
        src="assets/images/icon_calendar/info.svg"
        alt="info"
        class="icon-info" />
      <p class="mb-0 alert-text">
        Questa operazione sovrascrive tutte le modifiche precedentemente
        apportate ai posti disponibili.
      </p>
    </div>
    <div class="input-container">
      <p class="mb-0 input-label">Posti in azienda</p>
      <input [(ngModel)]="limit" nz-input type="number" class="input-number" />
    </div>
  </div>
  <div class="buttons-container">
    <button class="w-100 secondary-btn" (click)="closeModal()">Annulla</button>
    <button
      class="w-100 primary-btn"
      [disabled]="isChangeSeats()"
      (click)="save()">
      Salva
    </button>
  </div>
</div>
